import { render, staticRenderFns } from "./downloadPayslips.vue?vue&type=template&id=2afd69ee&scoped=true"
import script from "./downloadPayslips.vue?vue&type=script&lang=js"
export * from "./downloadPayslips.vue?vue&type=script&lang=js"
import style0 from "./downloadPayslips.vue?vue&type=style&index=0&id=2afd69ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afd69ee",
  null
  
)

export default component.exports